import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss']
})
export class ReceiptComponent implements OnInit {
  paymentDetails: any = {};

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.paymentDetails = {
        billId: params['billplz[id]'],
        paid: params['billplz[paid]'] === 'true',
        paidAt: params['billplz[paid_at]'] || 'N/A',
        signature: params['billplz[x_signature]']
      };
    });
  }
}